import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Grid } from "@mzc-pdc/ui";
import Typography from "@components_v2/typography/typography";
import TextField from "@components_v2/text-field/text-field";
import { LIMIT_CHAR } from "@constants";
import validateInput from "@cores/validateInput";
import { setValidationError, updateData } from "@modules/createAsset";

const DescriptionField = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const description = useSelector(({ createAsset }) => createAsset.data.description);
    const validationError = useSelector(
        ({ createAsset }) => createAsset.validationErrors?.description,
    );

    const onChangeDescription = (newDescription) => {
        dispatch(
            updateData({
                description: newDescription,
            }),
        );

        dispatch(
            setValidationError({
                key: `description`,
                error: validateInput(newDescription, { maxLength: LIMIT_CHAR.description }),
            }),
        );
    };

    return (
        <Grid container alignItems={"center"}>
            <Grid item sx={{ alignSelf: "flex-start", minWidth: "244px" }} alignItems={"center"}>
                <Typography variant={"body1"} component={"p"}>
                    {t(`common::label::Description`, `Description`)}
                </Typography>
            </Grid>
            <Grid
                item
                sx={{
                    flex: 1,
                    alignSelf: "flex-start",
                    maxWidth: "1000px",
                }}
            >
                <TextField
                    fullWidth
                    type={"text"}
                    multiline={true}
                    maxLength={LIMIT_CHAR.description}
                    length={(description || "").length}
                    defaultValue={description ?? ""} //Note: defaultValue 사용이유: value사용시 한글 입력하면 단어들이 분리되서 들어감
                    onChange={(e) => {
                        onChangeDescription(e.target.value);
                    }}
                    placeholder={t(
                        `common::label::Please enter a description of the asset.`,
                        `Please enter a description of the asset.`,
                    )}
                    error={validationError?.level}
                    helperText={
                        validationError?.message
                            ? t(
                                  `common::msg::${!!validationError?.message}`,
                                  validationError?.message,
                              )
                            : ""
                    }
                />
            </Grid>
        </Grid>
    );
};

export default DescriptionField;
